"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rupee = void 0;
var rupee = {
  "viewBox": "0 0 898 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M898 470v102q0 14-9 23t-23 9h-168q-23 144-129 234t-276 110q167 178 459 536 14 16 4 34-8 18-29 18h-195q-16 0-25-12-306-367-498-571-9-9-9-22v-127q0-13 9.5-22.5t22.5-9.5h112q132 0 212.5-43t102.5-125h-427q-14 0-23-9t-9-23v-102q0-14 9-23t23-9h413q-57-113-268-113h-145q-13 0-22.5-9.5t-9.5-22.5v-133q0-14 9-23t23-9h832q14 0 23 9t9 23v102q0 14-9 23t-23 9h-233q47 61 64 144h171q14 0 23 9t9 23z"
    }
  }]
};
exports.rupee = rupee;